/**
 * PM International
 *
 * Styles according to the Feidekai guidelines.
 */

import { ReactNode } from 'react';

interface ITypographyProps {
  readonly variant: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'small';
  readonly children: ReactNode;
}

export function Typography({ variant, children }: ITypographyProps) {
  if (variant === 'h1') {
    return <Heading1>{children}</Heading1>;
  }

  if (variant === 'h2') {
    return <Heading2>{children}</Heading2>;
  }

  if (variant === 'h3') {
    return <Heading3>{children}</Heading3>;
  }

  if (variant === 'h4') {
    return <Heading4>{children}</Heading4>;
  }

  if (variant === 'p') {
    return <Paragraph>{children}</Paragraph>;
  }

  if (variant === 'small') {
    return <Small>{children}</Small>;
  }

  return null;
}

interface IHeadingProps {
  readonly children: ReactNode;
}

function Heading1({ children }: IHeadingProps) {
  return (
    <h1
      style={{
        fontFamily: 'var(--pmi-font-family-headings)',
        fontWeight: 'var(--pmi-font-weigth-headings)',
        fontSize: '24px',
        lineHeight: '36px',
      }}
    >
      {children}
    </h1>
  );
}

function Heading2({ children }: IHeadingProps) {
  return (
    <h2
      style={{
        fontFamily: 'var(--pmi-font-family-headings)',
        fontWeight: 'var(--pmi-font-weigth-headings)',
        fontSize: '16px',
        lineHeight: '24px',
      }}
    >
      {children}
    </h2>
  );
}

function Heading3({ children }: IHeadingProps) {
  return (
    <h3
      style={{
        fontFamily: 'var(--pmi-font-family-headings)',
        fontWeight: 'var(--pmi-font-weigth-headings)',
        fontSize: '14px',
        lineHeight: '20px',
      }}
    >
      {children}
    </h3>
  );
}

function Heading4({ children }: IHeadingProps) {
  return (
    <h4
      style={{
        fontFamily: 'var(--pmi-font-family-headings)',
        fontWeight: 'var(--pmi-font-weigth-headings)',
        fontSize: '12px',
        lineHeight: '18px',
      }}
    >
      {children}
    </h4>
  );
}

function Paragraph({ children }: IHeadingProps) {
  return (
    <p
      style={{
        fontSize: '16px',
        lineHeight: '24px',
        minHeight: '24px',
      }}
    >
      {children}
    </p>
  );
}

function Small({ children }: IHeadingProps) {
  return (
    <small
      style={{
        fontSize: '12px',
        lineHeight: '14px',
        minHeight: '14px',
      }}
    >
      {children}
    </small>
  );
}
